export default __webpack_public_path__ + "static/media/perfil-1@3x.0556b5b4.png";